import styled from '@emotion/styled'
import { breakpointMaxQuery } from 'utils/functions/breakpoints'

export const Overlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.125);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  transition: opacity 0.25s ease, visibility 0.25s ease;
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};
`

export const Outer = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  max-width: 90vw;
  max-height: 90vh;
  min-width: 400px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);

  ${breakpointMaxQuery('xs')} {
    min-width: 300px;
    max-width: 95vw;
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 32px 32px 0;
  justify-content: space-between;
`

export const HeaderTitle = styled.div`
  flex: 1;
  font-weight: bold;
  font-size: 1.5em;
`

export const HeaderClose = styled.button`
  cursor: pointer;
  border-radius: 100%;
  border: none;
  width: 36px;
  height: 36px;
  padding: 0;
  background: transparent;

  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;

  &:hover {
    background: #f5f5f5;
  }
`

export const Body = styled.div`
  flex: 1;
  padding: 0 32px;
  overflow-y: auto;

  p {
    line-height: 1.5;
    margin: 0 0 24px 0;
  }
`

export const Footer = styled.div<{ isMobileView?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 32px;

  ${({ isMobileView }) =>
    isMobileView
      ? `
        flex-direction: column-reverse;
        gap: 12px;
      `
      : ''}

  ${breakpointMaxQuery('xs')} {
    flex-direction: column-reverse;
    gap: 12px;
    padding: 20px 24px;
  }
`

export const FooterAction = styled.button<{ isMobileView?: boolean }>`
  cursor: pointer;
  border-radius: 6px;
  padding: 12px 24px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  min-width: 140px;
  transition: all 0.2s ease-in-out;
  background-color: #2c2c2c;
  color: white;

  &:hover:not(:disabled) {
    background-color: #1a1a1a;
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0px);
    background-color: #0d0d0d;
  }

  ${({ isMobileView }) =>
    isMobileView
      ? `
        padding: 14px 24px;
        width: 100%;
      `
      : ''}

  ${breakpointMaxQuery('xs')} {
    padding: 14px 24px;
    width: 100%;
  }
`
